import { Component } from '@angular/core';
import {
  AgActionIconButtonComponent
} from '@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component';
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AlertStatus } from '@models/alerts/alerts-enums';
import { IndividualRecord } from '@models/individuals/Individual-record';

type ActionEvent = (data: IndividualRecord | undefined) => void;

type CellRendererParams = ICellRendererParams<IndividualRecord> & {
  open: ActionEvent,
  openAlerts: ActionEvent,
  openNotes: ActionEvent,
};

@Component({
  selector: 'app-ag-individual-actions',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    HasRoleDirective
  ],
  templateUrl: './ag-individual-actions.component.html',
  styleUrl: './ag-individual-actions.component.scss'
})
export class AgIndividualActionsComponent implements ICellRendererAngularComp {
  params!: CellRendererParams;
  numberOfAlerts = 0;
  numberOfNewAlerts = 0;

  alertIconClass = "";

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;
    this.numberOfAlerts = this.params.data?.alerts?.length ?? 0;
    this.numberOfNewAlerts = this.params.data?.alerts?.filter(alert => alert.status === AlertStatus.New && alert.isRead == false).length ?? 0;
    this.alertIconClass = "ic-alert-triangle-16 " + (this.numberOfNewAlerts ? "bg-red" : "");
    return true;
  }

  onOpenProfile(): void {
    this.params.open(this.params.data);
  }

  onOpenAlerts(): void {
    this.params.openAlerts(this.params.data);
  }

  onOpenNotes(): void {
    this.params.openNotes(this.params.data);
  }
}
